import "core-js/modules/es6.object.assign.js";
import { isSSR, client } from "./Platform.js";
import { getEmptyStorage, getStorage } from "../utils/web-storage.js";
export default {
  install: function install(_ref) {
    var $q = _ref.$q;
    var storage = isSSR === true || client.has.webStorage === false ? getEmptyStorage() : getStorage('session');
    $q.sessionStorage = storage;
    Object.assign(this, storage);
  }
};